<template>
  <div>
    <ul class="previous-position-timeline">
      <li>
        <div class="timeline-icon">
          <div class="circle"></div>
        </div>
        <div class="timeline-info">
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
              <span class="report-heading-2-text">前港積地</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="6"
            >
              <span class="report-location-text mr-4">{{
                reportDetails.previous_port
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-1-text">前港積地出港日時</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-body-text">{{
                toMDHHmm(reportDetails.previous_departure_at)
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-1-text">前港積揚地荷役終了日時</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-body-text">{{
                toMDHHmm(reportDetails.previous_cargo_handling_finish_at)
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-1-text">前港積揚荷役日時</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-3-text">入港</span>
              <span class="report-body-text">{{
                toMDHHmm(reportDetails.previous_arrived_at)
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-3-text">接岸</span>
              <span class="report-body-text">{{
                toMDHHmm(reportDetails.previous_berthed_at)
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-3-text">開始</span>
              <span class="report-body-text">{{
                toMDHHmm(reportDetails.previous_cargo_handling_start_at)
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-3-text">終了</span>
              <span class="report-body-text">{{
                toMDHHmm(reportDetails.previous_cargo_handling_finish_at)
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row id="report-dummy-row" vs-type="flex" class="mt-12 mb-12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="12"
            >
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-12 mb-12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="12"
            >
            </vs-col>
          </vs-row>
        </div>
      </li>
    </ul>

    <!-- 現在地 -->
    <ul class="current-location-timeline">
      <li>
        <div class="timeline-icon">
          <div class="circle"></div>
        </div>
        <div class="timeline-info">
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
              <span class="report-heading-2-text">現在地</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="6"
            >
              <span class="report-location-text mr-4">{{
                reportDetails.current_position_name
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-1-text">本船現在地時間</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-body-text">{{
                toMDHHmm(reportDetails.report_at)
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-12 mb-12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="12"
            >
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-12 mb-12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="12"
            >
            </vs-col>
          </vs-row>
        </div>
      </li>
    </ul>
    <!-- 目的地 -->
    <ul class="destination-timeline">
      <li>
        <div class="timeline-icon">
          <div class="circle"></div>
        </div>
        <div class="timeline-info">
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
              <span class="report-heading-2-text">目的地</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="6"
            >
              <span class="report-location-text mr-4">{{
                reportDetails.estimated_arrival_port
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="2"
            >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-heading-1-text">到着予定日時</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="5"
            >
              <span class="report-body-text">{{
                toMDHHmm(reportDetails.estimated_arrival_at) || "---"
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-12 mb-12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="12"
            >
            </vs-col>
          </vs-row>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { DateUtil } from "@/utils";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vesselReportView");
export default {
  name: "report-timeline",
  computed: {
    ...mapState({
      reportDetails: state => state.reportDetails
    }),
    toMDHHmm() {
      return function(value) {
        return DateUtil.toYMD(value, "MM月DD日 HH時mm分");
      };
    }
  }
};
</script>

<style lang="scss"></style>
